import { ComponentStyleConfig } from '@chakra-ui/react';

export const UserInfoCard: ComponentStyleConfig = {
  parts: ['container', 'header'],
  baseStyle: {
    container: {
      bg: 'surface2',
      border: '1px solid',
      borderColor: 'borderBase',
      height: 12,
      alignItems: 'center',
      px: 3,
      borderRadius: 4,
      width: '100%',
    },
    header: {
      marginLeft: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
};
